const countryCurrencyMap = {
  BR: "brl",
};

// Default to USD if country is not in our map
export const getCountryCurrency = () => {
  try {
    // Get user's locale and extract country code
    const locale = navigator.language || navigator.userLanguage;
    const countryCode = locale.split("-")[1] || locale;

    // Return appropriate currency or default to USD
    return countryCurrencyMap[countryCode.toUpperCase()] || "usd";
  } catch (error) {
    console.error("Error detecting currency:", error);
    return "usd";
  }
};
